import React from 'react';
import PropTypes from 'prop-types';
import { FaPaperclip, FaTimes } from 'react-icons/fa';

const TransactionDetailAttachment = ({ id, name, size, url, allow_remove, handleRemoveAttachment }) => (
  <div className="tw-inline-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-border-slate-200 tw-px-2 tw-py-1 tw-mr-1 tw-my-1 tw-rounded tw-bg-white tw-text-sm">
    <FaPaperclip size={11} className="tw-text-slate-400" />
    <a href={url} rel="noopener noreferrer" target="_blank" className="tw-text-blue-600 hover:tw-underline">
      {name} ({(size / 1024).toFixed(2)} kb)
    </a>

    {allow_remove && (
      <button
        type="button"
        onClick={() => handleRemoveAttachment(id)}
        className="tw-bg-transparent tw-border-0 tw-text-slate-400 hover:tw-text-red-500 tw-cursor-pointer tw-p-0.5"
      >
        <FaTimes size={11} />
      </button>
    )}
  </div>
);

TransactionDetailAttachment.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired,
  allow_remove: PropTypes.bool,
  handleRemoveAttachment: PropTypes.func.isRequired,
};

export default TransactionDetailAttachment;
